A library question component of an `ApplicationQuestionnaire`.

Either this or `question` must be provided if the `componentTypeCode` is `Question`.

The SEEK library question is sourced from the `applicationLibraryQuestionSuggestions` query.
